var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfitzCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#FFF595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65399 11.6402C7.64882 11.8305 7.68168 12.02 7.75067 12.1977C7.81966 12.3754 7.92342 12.5379 8.05601 12.6758C8.1886 12.8138 8.34739 12.9244 8.52329 13.0014C8.69918 13.0784 8.88871 13.1203 9.08099 13.1246H10.6946C11.0329 13.1166 11.3542 12.976 11.588 12.7338C11.8218 12.4916 11.9491 12.1675 11.9419 11.8326C11.9788 11.5603 11.9125 11.2842 11.7558 11.0574C11.5992 10.8307 11.3633 10.6694 11.0937 10.6046L8.50225 9.71361C8.23258 9.64885 7.99669 9.48754 7.84006 9.2608C7.68342 9.03405 7.61714 8.75793 7.65399 8.48567C7.64681 8.15073 7.77407 7.82663 8.00789 7.58442C8.24171 7.34222 8.563 7.20168 8.90132 7.1936H10.5149C10.707 7.19793 10.8964 7.23974 11.0722 7.31666C11.248 7.39357 11.4067 7.50406 11.5393 7.6418C11.6718 7.77955 11.7756 7.94183 11.8447 8.11936C11.9138 8.29689 11.9468 8.48617 11.9419 8.67636",
    stroke: "#1E1E1E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79395 6.34094V13.9771",
    stroke: "#1E1E1E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63576 9.87169C3.63394 9.05233 3.79562 8.24069 4.11152 7.48336C4.42742 6.72602 4.89132 6.03792 5.47658 5.45854C6.06185 4.87917 6.75695 4.41994 7.52198 4.10722C8.28702 3.7945 9.10691 3.63444 9.9346 3.63625C11.1891 3.66582 12.4176 3.99642 13.5146 4.59965C14.6116 5.20287 15.5443 6.06069 16.2326 7.09943M16.2326 7.09943V3.98256M16.2326 7.10029H13.433",
    stroke: "#1E1E1E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3639 10.1283C16.3536 10.9566 16.177 11.7746 15.8442 12.5346C15.5114 13.2947 15.0291 13.9815 14.4255 14.5552C13.1893 15.7375 11.5306 16.3874 9.81192 16.3629C6.19259 16.3629 3.9873 12.8988 3.9873 12.8988",
    stroke: "#1E1E1E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98633 12.8996H6.94485",
    stroke: "#1E1E1E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98633 12.8996V16.0173",
    stroke: "#1E1E1E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitzCashIcon);
export default __webpack_public_path__ + "static/media/profitz-cash-icon.7b3b206093012d6542cf5fe015f8359e.svg";
export { ForwardRef as ReactComponent };